export * from "./media-query.component";
